import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Container from "../components/container/container"
import { graphql } from "gatsby"
import Markdown from "react-markdown"
import * as styles from "../components/case-study/study.module.scss"

const CaseStudyPage = ({ data }) => {
  return (
    <Layout slug={`/case-study`}>
      <Seo title={data.strapiCaseStudies.Heading} />
      <div className={styles.study}>
        <div className={styles.study__banner}>
          <Container>
            <h1>{data.strapiCaseStudies.Heading}</h1>
          </Container>
        </div>
        {data.strapiCaseStudies.Sections.map((section, key) => (
          <div class={styles.study__sections} key={key}>
            <Container>
              {key % 2 ? (
                <div
                  className={`d-flex align-items-center justify-content-between ${styles.study__wrap}`}
                >
                  <div className={styles.study__section}>
                    <div
                      className={`${styles.study__section__image} ${styles.study__section__image__odd}`}
                    >
                      <div className={styles.study__section__image__bg}></div>
                      <img
                        src={section.Image.publicURL}
                        alt={section.Heading}
                      />
                    </div>
                  </div>
                  <div className={styles.study__section}>
                    <h2>{section.Heading}</h2>
                    <Markdown>{section.Body}</Markdown>
                  </div>
                </div>
              ) : (
                <div
                  className={`d-flex align-items-center justify-content-between ${styles.study__wrap}`}
                >
                  <div className={styles.study__section}>
                    <h2>{section.Heading}</h2>
                    <Markdown>{section.Body}</Markdown>
                  </div>
                  <div className={styles.study__section}>
                    <div className={`${styles.study__section__image}`}>
                      <div className={styles.study__section__image__bg}></div>
                      <img
                        src={section.Image.publicURL}
                        alt={section.Heading}
                      />
                    </div>
                  </div>
                </div>
              )}
            </Container>
          </div>
        ))}
      </div>
    </Layout>
  )
}

export default CaseStudyPage

export const query = graphql`
  query CaseStudyTemplate($id: String!) {
    strapiCaseStudies(id: { eq: $id }) {
      Heading
      Slug
      Summary
      Sections {
        Heading
        Body
        Image {
          publicURL
        }
      }
    }
  }
`
